import React from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import { Phone, WhatsApp, Brightness7, Brightness4 } from '@mui/icons-material';
import { useThemeToggle } from '../../hooks/useThemeToggle';

const FloatingButtons = () => {
  const { theme: currentTheme, toggleTheme } = useThemeToggle();
  const muiTheme = useTheme();

  const contactInfo = {
    phone: '+966 50 123 4567',
    whatsapp: '+966501234567',
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {/* Theme Toggle */}
      <IconButton
        onClick={toggleTheme}
        sx={{
          width: 56,
          height: 56,
          backgroundColor: muiTheme.palette.primary.main,
          color: muiTheme.palette.primary.contrastText,
          boxShadow: muiTheme.palette.mode === 'dark' 
            ? '0 4px 12px rgba(0,0,0,0.4)' 
            : '0 4px 12px rgba(0,0,0,0.15)',
          '&:hover': {
            backgroundColor: muiTheme.palette.primary.dark,
            transform: 'scale(1.1)',
            boxShadow: muiTheme.palette.mode === 'dark' 
              ? '0 6px 16px rgba(0,0,0,0.5)' 
              : '0 6px 16px rgba(0,0,0,0.2)',
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        {currentTheme === 'light' ? <Brightness4 /> : <Brightness7 />}
      </IconButton>

      {/* WhatsApp */}
      <IconButton
        href={`https://wa.me/${contactInfo.whatsapp}`}
        target="_blank"
        sx={{
          width: 56,
          height: 56,
          backgroundColor: '#25D366',
          color: 'white',
          boxShadow: muiTheme.palette.mode === 'dark' 
            ? '0 4px 12px rgba(37,211,102,0.4)' 
            : '0 4px 12px rgba(37,211,102,0.15)',
          '&:hover': {
            backgroundColor: '#128C7E',
            transform: 'scale(1.1)',
            boxShadow: muiTheme.palette.mode === 'dark' 
              ? '0 6px 16px rgba(37,211,102,0.5)' 
              : '0 6px 16px rgba(37,211,102,0.2)',
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <WhatsApp />
      </IconButton>

      {/* Phone */}
      <IconButton
        href={`tel:${contactInfo.phone}`}
        sx={{
          width: 56,
          height: 56,
          backgroundColor: '#2196F3',
          color: 'white',
          boxShadow: muiTheme.palette.mode === 'dark' 
            ? '0 4px 12px rgba(33,150,243,0.4)' 
            : '0 4px 12px rgba(33,150,243,0.15)',
          '&:hover': {
            backgroundColor: '#1976D2',
            transform: 'scale(1.1)',
            boxShadow: muiTheme.palette.mode === 'dark' 
              ? '0 6px 16px rgba(33,150,243,0.5)' 
              : '0 6px 16px rgba(33,150,243,0.2)',
          },
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <Phone />
      </IconButton>
    </Box>
  );
};

export default FloatingButtons;
